import { Controller } from "stimulus"
import posthog from 'posthog-js'

export default class extends Controller {
  static values = { host: String, messageId: Number, chatSessionId: Number, chatType: String }

  report() {
    if (!posthog || typeof posthog.capture !== 'function') { return }

    posthog.capture('Chatbot - Clicked Report Button', {
      event_properties: { type: 'survey_triggers' },
      external_link_host: this.hostValue || '',
      message_id: this.messageIdValue || null,
      chat_session_id: this.chatSessionIdValue || null,
      chat_type: this.chatTypeValue || ''
    })
  }
}
